export default {"src":"/_next/static/media/404_Isko.bc09fddb.svg","height":241,"width":305};